module.exports = __webpack_public_path__ + "img/u53.264ade50.png";